/**
 * Updates the application's theme by setting a new theme in the store.
 *
 * @param {AppTheme} theme - The theme to apply. Must be a valid value of the `AppTheme` type.
 *                           It changes the visual appearance of the app based on the selected theme (e.g., Light or Dark).
 *
 * @returns {void}
 */
import { useAppStore } from '~/stores/AppStore'
import type { AppTheme } from '~/types'

export default function useTheme(theme: AppTheme): void {
  const store = useAppStore()
  store.setTheme(theme)
}
